import React from 'react';
import PropTypes from 'prop-types';

import Grid from '~/components/core/Atomic/Grid/Grid';
import InnerTabs from '~/components/core/Layout/InnerTabs/InnerTabs';
import { PERMISSION_ACTIONS, PERMISSION_VERBS } from '~/components/core/Permissions/PermissionUtils';
import DocumentRequestsSection from '~/components/DocumentRequests/DocumentRequestsSection/DocumentRequestsSection';
import { useCms } from '~/components/hooks/useCms';
import { useHasPermission } from '~/components/hooks/useHasPermission';
import { CONFIGURATION_FEATURES_NAMES } from '~/Types';
import { isFeatureEnabled } from '~/Utils';

import CardDialog from '../CardDialog';
import { withClaim } from '../ClaimContainer';

import DocumentsContainer from './DocumentsContainer';

import styles from '../SystemConfiguration/systemConfiguration.module.scss';

function DocumentsScreen(props) {
  const { classes, claim, onAsyncClaimUpdate } = props;
  const { userOrganization } = useCms();
  const canReadDocuments = useHasPermission({
    action: PERMISSION_ACTIONS.CLAIM_DOCUMENT,
    verb: PERMISSION_VERBS.READ,
  });
  const showRequestsTab =
    isFeatureEnabled(userOrganization, CONFIGURATION_FEATURES_NAMES.DOCUMENT_REQUESTS) && canReadDocuments;

  function handleNewDocumentCreated() {
    onAsyncClaimUpdate();
  }

  const documentsProps = {
    classes,
    claim,
    onNewDocumentCreated: handleNewDocumentCreated,
    autoPaginateRowsPerPage: 25,
    showAddToChat: true,
    withCliveStatus: true,
    withCliveSidePanel: true,
    withInvoiceAnalysis: true,
  };

  if (!showRequestsTab) {
    return (
      <Grid container>
        <Grid item md={12}>
          <div className={classes.cardDivRow}>
            <CardDialog title="Documents">
              <DocumentsContainer
                {...documentsProps}
                maxHeight={`${window.innerHeight - 375}px`} // TODO - derive from bars size
              />
            </CardDialog>
          </div>
        </Grid>
      </Grid>
    );
  }

  const tabs = [
    {
      label: 'Documents',
      url: 'all',
      component: DocumentsContainer,
      // The tab strip takes the 40px the card title used to.
      props: { ...documentsProps, maxHeight: `${window.innerHeight - 415}px`, showEmptyState: true },
    },
    {
      label: 'Requests',
      url: 'requests',
      component: DocumentRequestsSection,
    },
  ];

  return (
    <Grid container>
      <Grid item md={12}>
        <div className={classes.cardDivRow}>
          <CardDialog noCardTitle dontTrack>
            <InnerTabs tabs={tabs} renderContainerClassName={styles.innerTabsContainer} />
          </CardDialog>
        </div>
      </Grid>
    </Grid>
  );
}

DocumentsScreen.propTypes = {
  classes: PropTypes.object.isRequired,
  claim: PropTypes.object.isRequired,
  onAsyncClaimUpdate: PropTypes.func.isRequired,
};

export default withClaim(DocumentsScreen);
